import { render, staticRenderFns } from "./PendencyModal.vue?vue&type=template&id=7bc5d7f0"
import script from "./PendencyModal.vue?vue&type=script&lang=js"
export * from "./PendencyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports